import { render, staticRenderFns } from "./FarmsEdit.vue?vue&type=template&id=be55d526&scoped=true"
import script from "./FarmsEdit.vue?vue&type=script&lang=js"
export * from "./FarmsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be55d526",
  null
  
)

export default component.exports